<template>
  <div>
    <chart
      v-if="data.loaded && data.labels.length"
      :chart-data="chartData"
      :chart-options="chartOptions"
    />
    <b-alert
      v-else
      show
      variant="warning"
      class="w-50 mx-auto text-center"
    >
      There's no data to show
    </b-alert>
  </div>
</template>
<script>
import Chart from '@/modules/reporting/components/Chart.vue';

export default {
  name: 'EventPerformanceChart',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    hasScrolls: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Chart,
  },
  data() {
    return {
      chartData: {
        labels: this.data.labels,
        datasets: [
          {
            type: 'bar',
            label: 'CLICKS',
            backgroundColor: '#293A73',
            hoverBackgroundColor: '#282E46',
            borderWidth: 0,
            data: this.data.clicks,
            yAxisID: 'Click-axis',
            order: 2,
          },
          {
            type: 'bar',
            label: 'SCROLLS',
            backgroundColor: '#AFA6E6',
            hoverBackgroundColor: '#3B3173',
            borderWidth: 0,
            data: this.data.scrolls,
            yAxisID: 'Scroll-axis',
            order: 2,
          },
          {
            type: 'line',
            label: 'CTR%',
            backgroundColor: '#0D74CE',
            borderColor: '#0D74CE',
            pointBackgroundColor: '#0D74CE',
            pointBorderColor: '#0D74CE',
            fill: false,
            borderWidth: 2,
            lineTension: 0.3,
            data: this.data.ctr,
            yAxisID: 'ctr-axis',
            ticks: {
              beginAtZero: true,
            },
          },
          {
            type: 'line',
            label: 'STR%',
            backgroundColor: '#523DC7',
            borderColor: '#523DC7',
            pointBackgroundColor: '#523DC7',
            pointBorderColor: '#523DC7',
            fill: false,
            borderWidth: 2,
            lineTension: 0.3,
            data: this.data.str,
            yAxisID: 'str-axis',
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
      chartOptions: {
        scales: {
          yAxes: [
            {
              id: 'Click-axis',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
                stepSize: 1,
              },
              gridLines: {
                color: '#666',
              },
              scaleLabel: {
                display: true,
                labelString: 'Clicks',
              },
            },
            {
              id: 'Scroll-axis',
              type: 'linear',
              position: 'right',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Scrolls',
              },
            },
            {
              id: 'ctr-axis',
              display: false,
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: '#ceced5',
              },
            },
            {
              id: 'str-axis',
              display: false,
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: '#ceced5',
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                autoSkip: false,
                maxRotation: 40,
                minRotation: 40,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 12,
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
      },
    };
  },
  created() {
    if (!this.hasScrolls) {
      const scrollIndex = this.chartData.datasets.findIndex((data) => data.label === 'SCROLLS');
      this.chartData.datasets.splice(scrollIndex, 1);

      const strIndex = this.chartData.datasets.findIndex((data) => data.label === 'STR%');
      this.chartData.datasets.splice(strIndex, 1);

      const scrollAxisIndex = this.chartOptions.scales.yAxes.findIndex((data) => data.id === 'Scroll-axis');
      this.chartOptions.scales.yAxes.splice(scrollAxisIndex, 1);

      const strAxisIndex = this.chartOptions.scales.yAxes.findIndex((data) => data.id === 'str-axis');
      this.chartOptions.scales.yAxes.splice(strAxisIndex, 1);
    }
  },
};
</script>
<style>
</style>
